import { createSlice } from '@reduxjs/toolkit'

export type OrderssState = {
  isDrilled: boolean
  duration: string
}

const initialState: OrderssState = {
  isDrilled: false,
  duration: 'LAST_30_DAYS',
}

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setIsDrilled: (state, action) => {
      state.isDrilled = action.payload
    },
    setDuration: (state, action) => {
      state.duration = action.payload
    },
  },
})

export const { setIsDrilled, setDuration } = orderSlice.actions
export default orderSlice.reducer
